import { Component, OnInit, Input, Output, OnDestroy, SimpleChanges, OnChanges, Inject, PLATFORM_ID } from '@angular/core';
import { SidenavMenuService } from './sidenav-menu.service';
import { EventEmitter } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { Router } from '@angular/router';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { ActivatedRoute} from '@angular/router';
@Component({
  selector: 'app-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss'],
  providers: [SidenavMenuService]
})
export class SidenavMenuComponent implements OnInit, OnDestroy {
  @Input() menuItems: any[] = [] // Input menu items
  @Input() accountMenuItems: any; // Input my account menu items as an object

  @Input() menuParentId: number;
  @Input() parentName: string;
  // @Input('menuParentId') menuParentId;
  @Output() emitPass: EventEmitter<any> = new EventEmitter()
  openMenus: Set<number> = new Set(); // Track open menus
  parentMenu: Array<any>;
  loggedIn;
  loginSubService;
  featureTags = {};
  storeDetails = {};
  setParentUrl:any;
  public sidenavMenuItems = {};

  constructor(private sidenavMenuService: SidenavMenuService, private apiService: ApiService,
    public router: Router, private notification: NotificationService, private subscription: SubscriptionService, public sharedDataService: SharedDataService,private route: ActivatedRoute,) { }


  ngOnInit() {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    if(this.featureTags && this.featureTags['sf_desktop_sub_cat']){
      if(this.featureTags && !this.featureTags['ftag_all_in_side_nav_fix']){
        this.menuItems = this.menuItems.filter(menu => menu.category_name !== 'ALL');
      }
    }
    this.setParentUrl = this.parentName
    
    this.loggedIn = this.apiService.loggedIn();
    this.loginSubService = this.apiService.getLogin().subscribe(message => {
      if (message) {
        this.loggedIn = message['loggedIn'];
      }
    });
    if(this.featureTags && this.featureTags['sf_desktop_sub_cat']){
      this.menuItems.forEach(menu => {
        menu.sub_list = menu.sub_list || [];       
      });
    }
    if(this.featureTags && this.featureTags['sf_side_menu_global_change']){
      if(this.accountMenuItems){
        this.sidenavMenuItems = this.accountMenuItems;        
      }
    }
    if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
      this.storeDetails = this.route.snapshot.data['store']['response']['data']['store'];
    }
    
  }
  ngOnDestroy() {
    !!this.loginSubService && !!this.loginSubService.unsubscribe();
  }
  handleChange(event) {
    if (event['href'] && event['href'] === 'sign-in') {
      var queryParams = this.router.url.includes('cart') ? { queryParams: { 'redirectURL': this.router.url } } : {};
      this.router.navigate(['/sign-in'], queryParams);
    } else if (event['name'] && event['name'] === 'Logout') {
      this.apiService.logout().subscribe(data => {
        if (data['response']['status'] === 1) {
          let storeData = sessionStorage.getItem('store');
          localStorage.clear();
          // sessionStorage.clear();
          sessionStorage.removeItem('booking_start_date');
          sessionStorage.removeItem('calendar_data_last');
          sessionStorage.removeItem('cardEnable');
          sessionStorage.removeItem('cart');
          sessionStorage.removeItem('cutoff');
          sessionStorage.removeItem('order_exist');
          sessionStorage.removeItem('cardEnable');
          sessionStorage.removeItem('recurring_frequencies');
          sessionStorage.removeItem('selected_delivery_calendar');
          sessionStorage.removeItem('selected_delivery_date');
          sessionStorage.removeItem('event_details');
          if (!!this.featureTags && this.featureTags['ftag_allow_product_to_customer_based_events']) {
            sessionStorage.removeItem('user_event_ids');
          }
          if (!!this.featureTags && this.featureTags['ftags_membership']) {
            sessionStorage.removeItem('membership_item');
          }
          // sessionStorage.removeItem('upcoming_event_dates');
          this.apiService.setLogin({
            loggedIn: false,
            userDetails: null
          });
          sessionStorage.setItem('store', storeData);
          this.subscription.subjectNext({ msg: 'logged out' });
          this.sharedDataService.cartDataSource.next(false)
          var queryParams = this.router.url.includes('cart') ? { queryParams: { 'redirectURL': this.router.url } } : {};
          this.router.navigate(['/sign-in'], queryParams);
          this.notification.success(data['response']['message'], 5000);
        } else {
          this.notification.error(data['response']['message'], 5000);
        }
      }, err => { console.log('get user details error', err) })
    } else {
      this.emitPass.emit(event);
    }
  }

  trackById(index: number, menu: any): number {
    return menu.id; // or any unique identifier in your menu items
  }
  onIconClick(event: MouseEvent, menuId: number): void {
    event.stopPropagation(); // Prevent click from bubbling up to <a>
    this.onClick(menuId); // Call your logic here
  }

  onClick(menuId: number) {
    this.toggleMenuItem(menuId);
    this.closeOtherSubMenus(this.menuItems, menuId);
  }
  
  toggleMenuItem(menuId: number) {
    let menuItem = document.getElementById('menu-item-' + menuId);
    let subMenu = document.getElementById('sub-menu-' + menuId);
    
    if (subMenu) {
      if (subMenu.classList.contains('show')) {
        subMenu.classList.remove('show');
        menuItem?.classList.remove('expanded');
      } else {
        subMenu.classList.add('show');
        menuItem?.classList.add('expanded');
      }
    }
  }
  
  closeOtherSubMenus(menu: Array<any>, menuId: number) {  
    let currentMenuItem = menu.find(item => item.id === menuId);
    if (currentMenuItem) {
      menu.forEach(item => {
        if (
          (item.id !== menuId && item.parentId === currentMenuItem.parentId) ||
          (currentMenuItem.parentId === 0 && item.id !== menuId)
        ) {
          let subMenu = document.getElementById('sub-menu-' + item.id);
          let menuItem = document.getElementById('menu-item-' + item.id);
  
          if (subMenu && subMenu.classList.contains('show')) {
            subMenu.classList.remove('show');
            menuItem?.classList.remove('expanded');
          }
        }
      });
    }
  }

  routeUrl(categoryUrl: any, n: string) {
    
    if (n === '1') {
      // If navigating to the parent menu item, use only the categoryUrl
      this.router.navigate(['/categories', categoryUrl.category_url]); // Adjust as per your router configuration
    } else if (n === '2') {
      // If there is a sub-item, get the first child using sub_list
      const childMenu = this.menuItems.find(item => item.category_url === categoryUrl.category_url)?.sub_list[0]; // Get the first sub-item
      if (childMenu) {
        this.router.navigate(['/categories', categoryUrl.category_url, childMenu.category_url]); // Adjust as per your router configuration
      }
    }
  }

}

